<div class="code project-code">
  <span
    class="clickable"
    tabindex="0"
    role="button"
    (click)="onProjectClick()"
    (keydown.enter)="onProjectClick()"
    (keydown.space)="onProjectClick()"
    >{{ 'projectEstimate.projectCard.projectCode' | translate }}:
    {{ project?.code }}</span
  >

  <ops-project-status
    [isPreview]="shouldShowStatusPreview"
    [selectedStatus]="projectStatus"
    [userRole]="userRole"
    (statusChanged)="onProjectStatusChange($event)"
  ></ops-project-status>
</div>
<div class="names">
  <div class="row-block">
    <div class="name-value">
      <span>{{ 'projectEstimate.projectCard.projectName' | translate }}</span>
      <div 
        class="clickable"
        tabindex="0"
        role="button"
        (click)="onProjectClick()"
        (keydown.enter)="onProjectClick()"
        (keydown.space)="onProjectClick()"
      >{{ project?.name }}</div>
    </div>
    <div
      class="name-value"
      *ngIf="isShowFiscalYear || (!shouldShowStatusPreview && fiscalYearList?.length > 0)"
    >
      <span [style.visibility]="!shouldShowStatusPreview ? 'visible' : 'hidden'">{{ 'projectEstimate.projectCard.fiscalYear' | translate }}</span>
      <div>
        <ops-fiscal-year
          [selectedStatus]="projectStatus"
          [selectedYear]="project.fiscalYear"
          [fiscalYearList]="fiscalYearList"
          [isPreviewMode]="isStatusPreview"
          (yearChanged)="onProjectFiscalYearChange($event)"
        ></ops-fiscal-year>
      </div>
    </div>
  </div>
  <div class="name-value">
    <span>{{ 'projectEstimate.projectCard.client' | translate }}</span>
    <div>{{ project?.client?.name }}</div>
  </div>
</div>
<div class="types">
  <span class="type"
    >{{ 'projectEstimate.projectCard.budgetType' | translate }}:
    {{ project?.budgetType | translate }}
  </span>
  <span class="type" #service>
    {{ 'projectEstimate.projectCard.service' | translate }}:
    <ng-container *ngFor="let service of project?.service; let last = last">
      {{ (service | translate) + (last ? '' : ', ') }}
    </ng-container>
  </span>
</div>
<ng-container *ngIf="detailed">
  <div class="estimates">
    <span
      >{{ 'projectEstimate.projectCard.estimateApproved' | translate }}: V{{
        project?.versionNumber ?? '-'
      }}</span
    >
    <span
      >{{ 'projectEstimate.projectCard.date' | translate }}:
      {{ project?.approvedDate | date : 'dd.MM.yyyy' }}</span
    >
    <span
      >{{ 'projectEstimate.projectCard.amount' | translate }}:
      {{ projectBaseCurrency }}{{ project?.expectedBudget | number }}</span
    >
  </div>
  <!-- <div class="invoice">
    <span>Invoice Number: {{ project?.invoice?.invoiceAmount }}</span>
    <span
      >Date:
      {{ project?.invoice?.paymentReceivedDate | date : 'dd.MM.yyyy' }}</span
    >
    <span
      >Amount Received: {{ companyBaseCurrency
      }}{{ project?.invoice?.receivedAmount | number }}</span
    >
    <span>Income Percentage: 27%</span>
  </div> -->
</ng-container>
